import { jsx as s, jsxs as S } from "@emotion/react/jsx-runtime";
import { useState as I, useMemo as y, useRef as v } from "react";
import { useTheme as E } from "@emotion/react";
import { useKeyboardEvents as g } from "@partoohub/hooks";
import { IconPrefix as h } from "@partoohub/ui";
import { StyledWrapper as k, StyledToggle as A, StyledIcon as T, StyledCheckbox as M } from "./SwitchTheme.styled.js";
import { ThemeMode as r } from "../../types/components/switchTheme.types.js";
const l = "data-theme-item", b = {
  [r.LIGHT]: "fa-sun",
  [r.DARK]: "fa-moon",
  [r.SYSTEM]: "fa-circle-half-stroke"
}, H = ({
  value: t,
  onChange: p,
  disabled: c = !1
}) => {
  const m = E(), [, f] = I(null), x = y(() => Object.values(r), []).indexOf(t), d = (e) => {
    c || p(e);
  };
  return /* @__PURE__ */ s(k, { activeIndex: x, "data-track": "switch-theme", children: Object.values(r).map((e) => {
    const u = v(null);
    return g({
      ref: u,
      onEnter: () => {
        d(e);
      },
      onArrowRight: (a) => {
        a?.preventDefault();
        const o = document.querySelectorAll(`[data-navigation="${l}"]`), n = Array.from(o).findIndex((i) => i === document.activeElement);
        n < o.length - 1 && o[n + 1].focus();
      },
      onArrowLeft: (a) => {
        a?.preventDefault();
        const o = document.querySelectorAll(`[data-navigation="${l}"]`), n = Array.from(o).findIndex((i) => i === document.activeElement);
        n > 0 && o[n - 1].focus();
      }
    }), /* @__PURE__ */ S(A, { "data-track": `switch-theme__item__${e}`, tabIndex: 0, ref: u, "data-active": t === e, "data-disabled": c, "data-navigation": l, onClick: () => d(e), onMouseEnter: () => f(e), onMouseLeave: () => f(null), children: [
      /* @__PURE__ */ s(T, { icon: [b[e], t === e ? h.SOLID : h.REGULAR], color: t === e ? m.colors.theme.background : m.colors.secondary.background, isActive: t === e, iconSize: "12px" }),
      /* @__PURE__ */ s(M, { type: "radio", checked: t === e, disabled: c })
    ] }, e);
  }) });
};
export {
  b as ICONS,
  H as SwitchTheme,
  l as THEME_ITEM
};
